<template>
  <base-dialog :visible="visible" :show-close="true" @open="open" @closed="closed">
    <template v-slot:header>
      <div>{{ title }}</div>
    </template>
    <el-form
      ref="form"
      class="form"
      :model="form"
      :rules="rules"
      label-width="88px"
      label-position="left"
    >
      <el-form-item prop="name" label="模板名称">
        <el-input v-model.trim="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="icon" label="设计图标" class="design-icon">
        <span class="icon-info">
          <svg-icon
            style="color: #fff"
            :icon-class="form.icon ? 'project_' + form.icon : 'project_' + projectIcons[0]"
          ></svg-icon>
        </span>
        <design-icon-popper
          style="margin: 8px"
          :icons="projectIcons"
          :cur-data="form"
          from="project"
          @changeData="changeProjectInfo"
        ></design-icon-popper>
      </el-form-item>
      <el-form-item prop="projectId" label="选择项目">
        <el-select
          v-model="form.projectId"
          :disabled="disableProjectId"
          placeholder="请选择"
          style="width: 100%"
          popper-class="select-project"
        >
          <el-option-group v-for="group in projects" :key="group.label" :label="group.label">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              v-tip
            ></el-option>
            <div v-if="group.options == 0" class="non-options">
              暂无数据
            </div>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="模板描述">
        <el-input v-model="form.description"></el-input>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="closed">取消</base-button>
      <base-button type="primary" @click="submit">确定</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import BaseDialog from "@/components/BaseComponents/Dialog"
import DesignIconPopper from "@/components/BaseComponents/DesignIconPopper"
import { getProjectList, createProjectTemplate } from "@/api/project/project"
import { loadingService } from "@/utils/ui"
import { projectIcons } from "@/views/Backend/Project/Basic/static"

export default {
  name: "create-dialog",
  components: { BaseButton, BaseDialog, DesignIconPopper },
  props: {
    from: {
      type: String,
      default: "template-list",
      validator(value) {
        return ["template-list", "project-list", "project-operation"].indexOf(value) !== -1
      }
    },
    visible: Boolean,
    projectId: String
  },
  data() {
    return {
      projectIcons,
      rules: {
        name: [{ required: true, message: "请输入项目模板名称", trigger: "blur" }],
        projectId: [{ required: true, message: "请选择项目", trigger: "blur" }]
      },
      form: {},
      projects: [],
      disableProjectId: false
    }
  },
  computed: {
    title() {
      if (["template-list", "project-list"].includes(this.from)) return "新建项目模板"
      else if (this.from == "project-operation") return "保存为项目模板"
      return ""
    }
  },
  created() {
    getProjectList({ type: "ALL" }).then(res => {
      let projects = res.map(i => ({ label: i.name, value: i.id }))
      this.projects = [
        { label: "系统", options: [{ value: "empty", label: "空白项目模板" }] },
        { label: "从已有项目新建", options: projects }
      ]
    })
  },
  methods: {
    open() {
      if (this.from == "project-operation") {
        this.form.projectId = this.projectId
        this.disableProjectId = true
      }
    },
    closed() {
      this.$emit("update:visible", false)
      this.$refs.form.clearValidate()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        let data = {
          name: this.form.name,
          icon: this.form.icon,
          templateDesc: this.form.description
        }
        const loadingInstance = loadingService()
        let projectId = this.form.projectId == "empty" ? null : this.form.projectId
        createProjectTemplate(projectId, data)
          .then(res => {
            this.afterSubmit(res)
          })
          .finally(() => loadingInstance.close())
      })
    },
    afterSubmit(newProject) {
      switch (this.from) {
        case "template-list": {
          this.$message.success("新建成功！")
          this.$router.push({
            name: "project-task-list",
            params: {
              projectId: newProject.id
            }
          })
          break
        }
        case "project-list":
        case "project-operation": {
          this.$emit("after-submit")
          break
        }
      }
    },
    changeProjectInfo(key, val) {
      this.$set(this.form, key, val)
    }
  }
}
</script>

<style lang="scss" scoped>
.non-options {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
  font-size: 14px;
  color: $color-font-second;
}
.form {
  padding-top: 14px;
  .design-icon {
    .icon-info {
      background: #1989fa;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      font-size: 30px;
      border-radius: 6px;
    }
    ::v-deep {
      .el-form-item__content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
      .el-select-dropdown .el-popper {
        max-width: 500px;
      }
    }
  }
}
</style>

<style lang="scss">
.select-project.el-select-dropdown {
  max-width: 500px;
  min-width: unset;
}
</style>
